import {useRef, useEffect} from 'react';

const useUnMountedState = () => {
  const unMounted = useRef(false);

  useEffect(
    () => () => {
      unMounted.current = true;
    },
    []
  );

  return unMounted;
};

export default useUnMountedState;
